angular.module('internal.homecharges',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.homecharges', {
            url: '/homecharges',
            views: {
                'content': {
                    templateUrl: 'js/internal/homecharges/homecharges.view.html',
                    controller:'HomeChargesCtrl'
                }
            }
        });
        $stateProvider.state('internal.on-going', {
            url: '/homecharges/ongoing?prev',
            views: {
                'content': {
                    templateUrl: 'js/internal/homecharges/on-going/on-going.view.html',
                    controller:'OnGogingCtrl'
                }
            }
        });        
    }]);